/**
 * Load a component.
 * @param {object} Vue
 * @param {string} Component name
 * @param {object} Component definition
 */
export const registerComponent = (app, name, def) => {
    app.component(name, def);
};
/**
 * Load a group of components.
 * @param {object} Vue
 * @param {object} Object of component definitions
 */
export const registerComponents = (app, components) => {
    for (const component in components) {
        registerComponent(app, component, components[component]);
    }
};
/**
 * Load a directive.
 * @param {object} Vue
 * @param {string} Directive name
 * @param {object} Directive definition
 */
export const registerDirective = (app, name, def) => {
    app.directive(name, def);
};
/**
 * Load a group of directives.
 * @param {object} Vue
 * @param {object} Object of directive definitions
 */
export const registerDirectives = (app, directives) => {
    for (const directive in directives) {
        registerDirective(app, directive, directives[directive]);
    }
};
/**
 * Install plugin if window.Vue available
 * @param {object} Plugin definition
 */
export const vueUse = (VuePlugin) => {
    // let GlobalVue = null;
    // if (typeof window !== 'undefined') {
    //   GlobalVue = window.Vue;
    // } else if (typeof global !== 'undefined') {
    //   GlobalVue = global.Vue;
    // }
    // if (GlobalVue) {
    //   GlobalVue.use(VuePlugin);
    // }
};
export const registerComponentProgrammatic = (app, property, component) => {
    app.config.globalProperties[property] = component;
};
